// The ramp model (§6). Encodes MAGNITUDE, never identity (D9).
// Given any set of segments, order by magnitude largest→smallest, keep the
// top 4, and collapse the remainder into a fifth "Everything else (n)" step
// at ramp-rest (§6.2). The ramp variables are the brand secondary scale (D10).
export const RAMP_VARS = ['var(--ramp-1)', 'var(--ramp-2)', 'var(--ramp-3)', 'var(--ramp-4)', 'var(--ramp-rest)']

export function buildRamp(segments, { noun = 'items', top = 4 } = {}) {
  const sorted = [...segments].sort((a, b) => b.value - a.value)
  const head = sorted.slice(0, top)
  const tail = sorted.slice(top)
  const steps = head.map((s, i) => ({ ...s, color: RAMP_VARS[i], rest: false }))
  if (tail.length) {
    const restValue = tail.reduce((sum, s) => sum + s.value, 0)
    steps.push({
      label: `Everything else (${tail.length} ${noun})`,
      value: restValue,
      color: RAMP_VARS[4],
      rest: true,
      members: tail,
    })
  }
  const total = steps.reduce((sum, s) => sum + s.value, 0)
  return { steps, total }
}
